import React from 'react';
import PropTypes from 'prop-types';

var getGroupLabel = function getGroupLabel(groupName) {
  if (!groupName) return null;

  if (typeof groupName === 'string') {
    return /*#__PURE__*/React.createElement("div", {
      className: "dropdown__group__label"
    }, groupName);
  }

  return groupName; // typeof groupName === children
};

var DropdownGroup = function DropdownGroup(_ref) {
  var groupName = _ref.groupName,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    role: "group",
    "aria-label": groupName,
    label: groupName,
    className: "dropdown__group",
    tabIndex: -1
  }, getGroupLabel(groupName), children);
};

DropdownGroup.propTypes = {
  children: PropTypes.node,

  /** Put in a string for dropdown groupName or a DOM node */
  groupName: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
};
DropdownGroup.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DropdownGroup",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "groupName": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "node"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }]
      },
      "required": false,
      "description": "Put in a string for dropdown groupName or a DOM node"
    }
  }
};
export default DropdownGroup;